<template>
    <div class="address-list page list-page">
        <div class="page--list" v-loading="loading">
            <div class="scroll-wrapper pd4 set--bottom-foot-padding">
                <el-table :data="tableData">
                    <el-table-column label="分公司" prop="areaName"></el-table-column>
                    <el-table-column label="收货人" prop="receiver"></el-table-column>
                    <el-table-column label="联系电话" prop="phone"></el-table-column>
                    <el-table-column label="地址" prop="address"></el-table-column>
                    <el-table-column label="操作" fixed="right" v-if="auth.edit">
                        <template slot-scope="scope">
                            <el-button type="text" @click.stop="handleEdit(scope.$index, scope.row)"> 编辑 </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-dialog
                :visible="showEditPupop"
                title="修改收货地址"
                @close="handleIssueClose"
                width="600px"
                class="batch-express"
            >
                <el-form
                    label-suffix=": "
                    label-width="150px"
                    class="private"
                    ref="form"
                    :model="PB"
                    :rules="rules"
                    @submit.prevent="handleBulkIssue"
                >
                    <el-form-item label="分公司">
                        <el-input v-model="PB.areaName" maxlength="20" class="width2" disabled></el-input>
                    </el-form-item>
                    <el-form-item prop="receiver" label="收货人姓名">
                        <el-input v-model="PB.receiver" maxlength="10" class="width2"></el-input>
                    </el-form-item>
                    <el-form-item prop="phone" label="联系电话">
                        <el-input v-model="PB.phone" maxlength="11" class="width2" type="text"></el-input>
                    </el-form-item>
                    <el-form-item label="收货人地址" required>
                        <div>
                            <el-select v-model="PB.province" class="width1" @change="e => handleRegionSelect(e, 1)">
                                <el-option
                                    v-for="p in regionList1"
                                    :value="p.name"
                                    :key="p.id"
                                    :label="p.name"
                                ></el-option>
                            </el-select>
                            <el-select v-model="PB.city" class="width1" @change="e => handleRegionSelect(e, 2)">
                                <el-option
                                    v-for="p in regionList2"
                                    :value="p.name"
                                    :key="p.id"
                                    :label="p.name"
                                ></el-option>
                            </el-select>
                            <el-select v-model="PB.county" class="width1">
                                <el-option
                                    v-for="p in regionList3"
                                    :value="p.name"
                                    :key="p.id"
                                    :label="p.name"
                                ></el-option>
                            </el-select>
                            <el-input
                                v-model="PB.address"
                                maxlength="200"
                                type="textarea"
                                class="address-input"
                            ></el-input>
                        </div>
                    </el-form-item>
                </el-form>

                <div slot="footer">
                    <el-button @click="handleIssueClose">返回</el-button>
                    <el-button @click="handleBulkIssue" type="primary">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import forList from '@/mixin/forList';
    import forEdit from '@/mixin/forEdit';
    import { Loading } from 'element-ui';
    // 函数创建一个空的菜单数据
    const initialPB = () => ({
        province: '', //省
        city: '', //市
        area: '', //区
        name: '', //名称
    });
    export default {
        mixins: [forList, forEdit],
        data() {
            return {
                loading: false,
                list: [],
                provinceOptions: [],
                cityOptions: [],
                areaOptions: [],
                value: '',

                tableData: [],
                multipleSelection: [],

                PB: {
                    id: '', // 357
                    receiver: '', // 白菜1111
                    phone: '', // 15828254251
                    province: '', // 四川
                    city: '', // 成都
                    county: '', // 锦江区
                    address: '', // 11111
                },
                rules: {
                    receiver: { required: true, message: '请输入收货人姓名' },
                    phone: { required: true, message: '请输入收货人联系电话' },
                },

                regionList1: [],
                regionList2: [],
                regionList3: [],

                showEditPupop: false,

                batchDialogVisible: false, //批量操作隐藏显示的弹窗
                batchRadio: 0,
            };
        },

        methods: {
            fetchGegion(preid = 0, cls = 1) {
                const clsName = ['province', 'city', 'county'][cls - 1];
                return this.$axios({
                    url: 'api/order/areaCity',
                    params: { preid },
                })
                    .then(res => {
                        if (res.code === 2000) {
                            const { list } = res.data;
                            this[`regionList${cls}`] = list;
                            return list;
                        } else if (res.code !== 1003) return Promise.reject(res);
                    })
                    .then(supList => {
                        const supText = this.PB[clsName];
                        if (cls < 3 && supText) {
                            const supItem = supList.find(it => it.name === supText);
                            if (supItem?.id) {
                                cls++;
                                return this.fetchGegion(supItem.id, cls);
                            }
                        }
                    })
                    .catch(reason => console.log('获取地区数据失败', reason));
            },
            handleRegionSelect(value, cls) {
                const keys = ['province', 'city', 'county'];
                for (let i = cls + 1; i <= 3; i++) {
                    this.PB[keys[i - 1]] = '';
                    this[`regionList${i}`] = [];
                }
                const item = this[`regionList${cls}`].find(it => it.name === value);
                this.fetchGegion(item.id, cls + 1);
            },
            async fetchData() {
                if (this.loading) return;
                this.loading = true;

                this.$axios({
                    url: 'api/areaAddress/queryAllList',
                    method: 'post',
                })
                    .then(res => {
                        if (res.code === 2000 && res.data.list) {
                            this.tableData = res.data.list;
                        } else if (res.code !== 1003) return Promise.reject(res);
                    })
                    .catch(reason => {
                        console.warn('获取数据失败', reason);
                        this.$message({
                            message: reason.msg || '获取数据失败',
                            type: 'warning',
                        });
                    })
                    .then(() => (this.loading = false));
            },
            // 编辑
            handleEdit(index) {
                this.showEditPupop = true;
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                    const data = this.tableData[index];

                    this.PB = Object.assign({}, data);

                    this.fetchGegion();
                });
            },
            handleIssueClose() {
                this.showEditPupop = false;
            },
            handleBulkIssue() {
                let loadingRef;
                this.$refs.form
                    .validate()
                    .then(res => {
                        const { province, city, area, address } = this.PB;
                        if (!province) return Promise.reject('请选择省份');
                        if (!city) return Promise.reject('请选择城市');

                        if (!address.trim()) return Promise.reject('请填写收货地址');
                    })
                    .then(res => {
                        loadingRef = Loading.service();
                        return this.$axios({
                            url: 'api/areaAddress/saveAreaAddress',
                            method: 'post',
                            data: {
                                id: this.PB.id,
                                receiver: this.PB.receiver,
                                province: this.PB.province,
                                city: this.PB.city,
                                county: this.PB.county,
                                address: this.PB.address,
                                phone: this.PB.phone,
                            },
                        });
                    })
                    .then(res => {
                        if (loadingRef) loadingRef.close();
                        if (res.code === 2000) {
                            this.$message({
                                message: '修改成功',
                                type: 'success',
                            });
                            this.showEditPupop = false;
                            this.fetchData();
                        } else if (res.code !== 1003) return Promise.reject(res);
                    });
                // .catch(reason => {
                //     if (reason !== false) {
                //         // false 是验证没通过
                //         if (loadingRef) loadingRef.close();
                //         console.log('修改失败', reason);
                //         if (typeof reason === 'object') reason = reason.msg;
                //         this.$message({
                //             message: reason || '修改失败',
                //             type: 'error',
                //         });
                //     }
                // });
            },
        },
        created() {
            // this.auth.add = this.$hasAuthFor("/api/areaCity/saveAreaCity");
            // this.auth.delete = this.$hasAuthFor("/api/areaCity/deleteAreaCity");
            this.auth.edit = this.$hasAuthFor('/api/areaAddress/saveAreaAddress');
            // this.auth.batch = this.$hasAuthFor("/api/areaCity/bachUpdateState");
        },
    };
</script>

<style></style>
